import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTVs } from "../hooks/useTVQueries.jsx";
import useAuthStore from "../store/authStore.jsx";
import { tvApi } from "../api/tvApi.jsx";

const TVListPage = () => {
  const navigate = useNavigate();
  const { isAuthenticated, user, logout } = useAuthStore();
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // TV 목록 가져오기
  const {
    data: tvsData,
    isLoading: tvsLoading,
    error: tvsError,
    refetch: refetchTVs,
  } = useTVs();

  // TV 클릭 핸들러 - 동적 URL로 이동
  const handleTVClick = (tv) => {
    if (tv.name) {
      navigate(`/${tv.name}`);
    }
  };

  // 로그인 버튼 클릭
  const handleLoginClick = () => {
    navigate("/login");
  };

  // 현황판 설정 버튼 클릭
  const handleAdminClick = () => {
    navigate("/admin");
  };

  // 로그아웃 처리
  const handleLogout = async () => {
    try {
      await logout();
      setShowLogoutModal(false);
    } catch (error) {
      setShowLogoutModal(false);
    }
  };

  // 로딩 중
  if (tvsLoading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "40px",
            textAlign: "center",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
          }}
        >
          <div
            style={{
              width: "40px",
              height: "40px",
              border: "4px solid #f3f3f3",
              borderTop: "4px solid #667eea",
              borderRadius: "50%",
              animation: "spin 1s linear infinite",
              margin: "0 auto 20px",
            }}
          ></div>
          <p style={{ color: "#666", fontSize: "16px", margin: 0 }}>
            📺 현황판 목록을 불러오는 중...
          </p>
        </div>
        <style jsx>{`
          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }
        `}</style>
      </div>
    );
  }

  // 에러 발생
  if (tvsError) {
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            background: "white",
            borderRadius: "12px",
            padding: "40px",
            textAlign: "center",
            boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
            maxWidth: "400px",
          }}
        >
          <div style={{ fontSize: "48px", marginBottom: "20px" }}>⚠️</div>
          <h2 style={{ color: "#dc3545", marginBottom: "10px" }}>오류 발생</h2>
          <p style={{ color: "#666", marginBottom: "20px" }}>
            현황판 목록을 불러오는 중 오류가 발생했습니다.
          </p>
          <button
            onClick={() => refetchTVs()}
            style={{
              background: "linear-gradient(45deg, #667eea, #764ba2)",
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "10px 20px",
              fontSize: "14px",
              cursor: "pointer",
            }}
          >
            다시 시도
          </button>
        </div>
      </div>
    );
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
        padding: "20px",
      }}
    >
      {/* 헤더 */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "40px",
          maxWidth: "1200px",
          margin: "0 auto 40px",
        }}
      >
        {/* 로고 및 제목 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          <div
            style={{
              fontSize: "48px",
              background: "rgba(255,255,255,0.2)",
              borderRadius: "12px",
              padding: "10px",
              backdropFilter: "blur(10px)",
            }}
          >
            📺
          </div>
          <div>
            <h1
              style={{
                margin: 0,
                fontSize: "28px",
                fontWeight: "700",
                color: "white",
                textShadow: "0 2px 4px rgba(0,0,0,0.3)",
              }}
            >
              JDLive
            </h1>
            <p
              style={{
                margin: 0,
                fontSize: "16px",
                color: "rgba(255,255,255,0.9)",
                fontWeight: "500",
              }}
            >
              현황판을 선택하여 시작하세요
            </p>
          </div>
        </div>

        {/* 로그인/설정 버튼 */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "15px",
          }}
        >
          {isAuthenticated ? (
            <>
              {/* 로그인된 상태 */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "15px",
                  background: "rgba(255,255,255,0.1)",
                  borderRadius: "25px",
                  padding: "8px 20px",
                  backdropFilter: "blur(10px)",
                }}
              >
                <div
                  style={{
                    fontSize: "12px",
                    color: "rgba(255,255,255,0.9)",
                    textAlign: "right",
                  }}
                >
                  <div style={{ fontWeight: "600" }}>
                    {user?.name || user?.signInId}님
                  </div>
                  <div style={{ opacity: 0.8 }}>관리자</div>
                </div>
                <button
                  onClick={handleAdminClick}
                  style={{
                    background: "rgba(255,255,255,0.2)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.3)",
                    borderRadius: "20px",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "500",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    backdropFilter: "blur(10px)",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.3)";
                    e.target.style.transform = "translateY(-1px)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.2)";
                    e.target.style.transform = "translateY(0)";
                  }}
                >
                  ⚙️ 현황판 설정
                </button>
                <button
                  onClick={() => setShowLogoutModal(true)}
                  style={{
                    background: "rgba(255,255,255,0.15)",
                    color: "white",
                    border: "1px solid rgba(255,255,255,0.3)",
                    borderRadius: "20px",
                    padding: "8px 12px",
                    fontSize: "12px",
                    cursor: "pointer",
                    transition: "all 0.2s",
                    backdropFilter: "blur(10px)",
                  }}
                  onMouseOver={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.25)";
                  }}
                  onMouseOut={(e) => {
                    e.target.style.background = "rgba(255,255,255,0.15)";
                  }}
                >
                  로그아웃
                </button>
              </div>
            </>
          ) : (
            <>
              {/* 로그인 안된 상태 */}
              <button
                onClick={handleLoginClick}
                style={{
                  background: "rgba(255,255,255,0.2)",
                  color: "white",
                  border: "1px solid rgba(255,255,255,0.4)",
                  borderRadius: "25px",
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  backdropFilter: "blur(10px)",
                  boxShadow: "0 4px 15px rgba(255,255,255,0.1)",
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.3)";
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow = "0 6px 20px rgba(255,255,255,0.2)";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "rgba(255,255,255,0.2)";
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow = "0 4px 15px rgba(255,255,255,0.1)";
                }}
              >
                🔐 로그인하기
              </button>
            </>
          )}
        </div>
      </div>

      {/* TV 목록 그리드 */}
      <div
        style={{
          maxWidth: "1200px",
          margin: "0 auto",
        }}
      >
        {tvsData && tvsData.length > 0 ? (
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
              gap: "24px",
              padding: "0 20px",
            }}
          >
            {tvsData.map((tv, index) => (
              <div
                key={tv.id}
                onClick={() => handleTVClick(tv)}
                style={{
                  background: "rgba(255,255,255,0.95)",
                  borderRadius: "16px",
                  padding: "24px",
                  cursor: "pointer",
                  transition: "all 0.3s ease",
                  boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
                  backdropFilter: "blur(10px)",
                  border: "1px solid rgba(255,255,255,0.3)",
                  position: "relative",
                  overflow: "hidden",
                  transform: "translateY(0) scale(1)",
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.transform =
                    "translateY(-8px) scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 15px 35px rgba(0,0,0,0.25)";
                  e.currentTarget.style.background = "rgba(255,255,255,1)";
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.transform = "translateY(0) scale(1)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(0,0,0,0.15)";
                  e.currentTarget.style.background = "rgba(255,255,255,0.95)";
                }}
              >
                {/* 상태 인디케이터 */}
                <div
                  style={{
                    position: "absolute",
                    top: "16px",
                    right: "16px",
                    width: "12px",
                    height: "12px",
                    borderRadius: "50%",
                    background: tv.enabled
                      ? "linear-gradient(45deg, #00b894, #00cec9)"
                      : "linear-gradient(45deg, #e17055, #d63031)",
                    boxShadow: tv.enabled
                      ? "0 0 10px rgba(0, 184, 148, 0.5)"
                      : "0 0 10px rgba(225, 112, 85, 0.5)",
                  }}
                ></div>

                {/* TV 아이콘 */}
                <div
                  style={{
                    width: "60px",
                    height: "60px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    borderRadius: "16px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    fontSize: "28px",
                    marginBottom: "20px",
                    boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                  }}
                >
                  📺
                </div>

                {/* TV 정보 */}
                <div>
                  <h3
                    style={{
                      margin: "0 0 8px 0",
                      fontSize: "20px",
                      fontWeight: "700",
                      color: "#2d3436",
                      lineHeight: "1.3",
                    }}
                  >
                    {tv.name || `TV ${tv.id}`}
                  </h3>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                      marginBottom: "12px",
                    }}
                  >
                    <span
                      style={{
                        fontSize: "12px",
                        background: tv.enabled
                          ? "linear-gradient(45deg, #00b894, #00cec9)"
                          : "linear-gradient(45deg, #e17055, #d63031)",
                        color: "white",
                        padding: "4px 8px",
                        borderRadius: "12px",
                        fontWeight: "600",
                      }}
                    >
                      {tv.enabled ? "🟢 활성" : "🔴 비활성"}
                    </span>
                  </div>

                  <div
                    style={{
                      fontSize: "14px",
                      color: "#636e72",
                      lineHeight: "1.5",
                    }}
                  >
                    <div style={{ marginBottom: "4px" }}>
                      📋 컨텐츠: {tv.contentCount || 0}개
                    </div>
                    <div style={{ marginBottom: "4px" }}>
                      🎵 배경음악: {tv.bgmCount || 0}개
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div
            style={{
              background: "rgba(255,255,255,0.95)",
              borderRadius: "16px",
              padding: "60px 40px",
              textAlign: "center",
              boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
              backdropFilter: "blur(10px)",
              maxWidth: "500px",
              margin: "0 auto",
            }}
          >
            <div
              style={{ fontSize: "72px", marginBottom: "24px", opacity: 0.7 }}
            >
              📺
            </div>
            <h3
              style={{
                margin: "0 0 16px 0",
                fontSize: "24px",
                fontWeight: "700",
                color: "#2d3436",
              }}
            >
              등록된 현황판이 없습니다
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                fontSize: "16px",
                color: "#636e72",
                lineHeight: "1.6",
              }}
            >
              현황판을 생성하려면 관리자로 로그인하여
              <br />
              현황판 설정에서 새로운 현황판을 추가해주세요.
            </p>
            {!isAuthenticated && (
              <button
                onClick={handleLoginClick}
                style={{
                  background: "linear-gradient(45deg, #667eea, #764ba2)",
                  color: "white",
                  border: "none",
                  borderRadius: "25px",
                  padding: "12px 24px",
                  fontSize: "16px",
                  fontWeight: "600",
                  cursor: "pointer",
                  transition: "all 0.3s",
                  boxShadow: "0 4px 15px rgba(102, 126, 234, 0.4)",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-2px)";
                  e.target.style.boxShadow =
                    "0 6px 20px rgba(102, 126, 234, 0.6)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)";
                  e.target.style.boxShadow =
                    "0 4px 15px rgba(102, 126, 234, 0.4)";
                }}
              >
                🔐 관리자 로그인
              </button>
            )}
          </div>
        )}
      </div>

      {/* 로그아웃 확인 모달 */}
      {showLogoutModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 10000,
            backdropFilter: "blur(4px)",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: "16px",
              padding: "32px",
              maxWidth: "400px",
              width: "90%",
              boxShadow: "0 20px 40px rgba(0,0,0,0.3)",
            }}
          >
            <h3
              style={{
                margin: "0 0 16px 0",
                fontSize: "20px",
                fontWeight: "700",
                color: "#2d3436",
                textAlign: "center",
              }}
            >
              로그아웃 확인
            </h3>
            <p
              style={{
                margin: "0 0 24px 0",
                fontSize: "16px",
                color: "#636e72",
                textAlign: "center",
                lineHeight: "1.5",
              }}
            >
              정말로 로그아웃 하시겠습니까?
            </p>
            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                onClick={() => setShowLogoutModal(false)}
                style={{
                  background: "#f8f9fa",
                  color: "#636e72",
                  border: "1px solid #dee2e6",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseOver={(e) => {
                  e.target.style.background = "#e9ecef";
                }}
                onMouseOut={(e) => {
                  e.target.style.background = "#f8f9fa";
                }}
              >
                취소
              </button>
              <button
                onClick={handleLogout}
                style={{
                  background: "linear-gradient(45deg, #e17055, #d63031)",
                  color: "white",
                  border: "none",
                  borderRadius: "8px",
                  padding: "10px 20px",
                  fontSize: "14px",
                  fontWeight: "500",
                  cursor: "pointer",
                  transition: "all 0.2s",
                }}
                onMouseOver={(e) => {
                  e.target.style.transform = "translateY(-1px)";
                }}
                onMouseOut={(e) => {
                  e.target.style.transform = "translateY(0)";
                }}
              >
                로그아웃
              </button>
            </div>
          </div>
        </div>
      )}

      {/* 스피너 애니메이션을 위한 CSS */}
      <style jsx>{`
        @keyframes spin {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};
export default TVListPage;
